var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBallcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14872 17.8513 3.90727e-07 11.5 2.51711e-07C5.14872 1.12695e-07 -1.12363e-07 5.14872 -2.5097e-07 11.5C-3.89578e-07 17.8513 5.14872 23 11.5 23Z",
    fill: "#8D9091"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3094 16.2553C13.3094 17.2592 12.4943 18.0742 11.5004 18.0742C10.5064 18.0742 9.69141 17.2592 9.69141 16.2553C9.69141 15.2514 10.5064 14.4463 11.5004 14.4463C12.4943 14.4463 13.3094 15.2613 13.3094 16.2553Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5203 15.2017C12.3949 15.2017 13.1305 15.8279 13.3094 16.6529C13.3392 16.5336 13.3491 16.4044 13.3491 16.2752C13.3491 15.2713 12.5341 14.4463 11.5203 14.4463C10.5064 14.4463 9.69141 15.2613 9.69141 16.2752C9.69141 16.4044 9.70135 16.5336 9.73117 16.6529C9.90014 15.8279 10.6357 15.2017 11.5203 15.2017Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13769 15.4743C6.91902 16.2297 6.12386 16.6571 5.36846 16.4385C4.61305 16.2198 4.18565 15.4246 4.40432 14.6692C4.62299 13.9138 5.41816 13.4864 6.17356 13.7051C6.92896 13.9238 7.35635 14.7189 7.13769 15.4743Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00706 14.2617C6.66307 14.4506 7.07059 15.0867 7.02089 15.7427C7.07059 15.6532 7.1004 15.5638 7.13022 15.4743C7.34889 14.7189 6.9215 13.9238 6.1661 13.7051C5.4107 13.4864 4.62547 13.9138 4.39686 14.6692C4.36704 14.7686 4.34717 14.8581 4.34717 14.9575C4.65529 14.371 5.34111 14.0729 5.99712 14.2617L6.00706 14.2617Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57967 13.4537C2.40075 14.0501 1.8342 14.4079 1.30741 14.2489C0.780617 14.0898 0.492372 13.4835 0.671283 12.8871C0.850194 12.2908 1.41674 11.9329 1.94354 12.092C2.47033 12.251 2.75858 12.8573 2.57967 13.4537Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81091 12.5393C2.26813 12.6784 2.54643 13.1555 2.48679 13.6724C2.51661 13.6028 2.54643 13.5332 2.57625 13.4537C2.75516 12.8573 2.46691 12.251 1.94012 12.092C1.41333 11.9329 0.846776 12.2908 0.667865 12.8871C0.647986 12.9667 0.628104 13.0362 0.618164 13.1157C0.856712 12.6486 1.34375 12.4001 1.80097 12.5293L1.81091 12.5393Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8871 15.4743C16.1057 16.2297 16.9009 16.6571 17.6563 16.4385C18.4117 16.2198 18.8391 15.4246 18.6204 14.6692C18.4018 13.9138 17.6066 13.4864 16.8611 13.7051C16.1057 13.9238 15.6783 14.7189 15.897 15.4743L15.8871 15.4743Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0202 14.2617C16.3642 14.4506 15.9566 15.0867 16.0063 15.7427C15.9566 15.6532 15.9268 15.5638 15.897 15.4743C15.6783 14.7189 16.1057 13.9238 16.8611 13.7051C17.6165 13.4864 18.4018 13.9138 18.6304 14.6692C18.6602 14.7686 18.6801 14.8581 18.6801 14.9575C18.3719 14.371 17.6861 14.0729 17.0301 14.2617L17.0202 14.2617Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4584 13.4537C20.6373 14.0501 21.2039 14.4079 21.7306 14.2489C22.2574 14.0898 22.5457 13.4835 22.3668 12.8871C22.1879 12.2908 21.6213 11.9329 21.0945 12.092C20.5677 12.251 20.2795 12.8573 20.4584 13.4537Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2237 12.5393C20.7665 12.6784 20.4882 13.1555 20.5478 13.6724C20.518 13.6028 20.4882 13.5332 20.4584 13.4537C20.2795 12.8573 20.5677 12.251 21.0945 12.092C21.6213 11.9329 22.1879 12.2908 22.3668 12.8871C22.3867 12.9667 22.4065 13.0362 22.4165 13.1157C22.1779 12.6486 21.6909 12.4001 21.2337 12.5293L21.2237 12.5393Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9138 9.54505C12.9138 10.3303 12.2777 10.9763 11.4826 10.9763C10.6874 10.9763 10.0513 10.3402 10.0513 9.54505C10.0513 8.74989 10.6874 8.11377 11.4826 8.11377C12.2777 8.11377 12.9138 8.74989 12.9138 9.54505Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4805 8.71014C12.1762 8.71014 12.7527 9.19717 12.8819 9.85318C12.9018 9.75379 12.9118 9.65439 12.9118 9.55499C12.9118 8.75983 12.2657 8.11377 11.4705 8.11377C10.6754 8.11377 10.0293 8.75983 10.0293 9.55499C10.0293 9.65439 10.0392 9.75379 10.0591 9.85318C10.1983 9.19717 10.7748 8.71014 11.4606 8.71014L11.4805 8.71014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08739 8.92135C7.90848 9.51772 7.29223 9.85566 6.69586 9.67675C6.09949 9.49784 5.76155 8.88159 5.94046 8.28522C6.11937 7.68885 6.73562 7.35091 7.33199 7.52982C7.92836 7.70873 8.2663 8.32498 8.08739 8.92135Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19465 7.97631C7.7115 8.1254 8.03951 8.62237 7.98981 9.13923C8.02957 9.06965 8.05939 9.00007 8.07926 8.92056C8.25818 8.32419 7.92024 7.698 7.32387 7.52903C6.7275 7.35011 6.11125 7.698 5.93234 8.28443C5.91246 8.36394 5.89258 8.43352 5.89258 8.51304C6.14107 8.05582 6.6778 7.81727 7.19465 7.96637L7.19465 7.97631Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4514 7.31053C4.31224 7.77768 3.86496 8.05599 3.4475 7.93671C3.03005 7.81744 2.81138 7.3304 2.95053 6.86324C3.08968 6.39609 3.53696 6.11779 3.95442 6.23706C4.37188 6.35633 4.59055 6.84337 4.4514 7.31053Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84301 6.58494C4.20083 6.69427 4.41949 7.07198 4.37973 7.4795C4.40955 7.4298 4.42943 7.37016 4.44931 7.31052C4.58846 6.84336 4.35985 6.35633 3.95233 6.23706C3.53488 6.11779 3.0876 6.39609 2.94845 6.86324C2.92857 6.92288 2.91863 6.98252 2.90869 7.04216C3.09754 6.67439 3.48518 6.47561 3.84301 6.58494Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9619 8.92135C15.1409 9.51772 15.7571 9.85566 16.3535 9.67675C16.9498 9.49784 17.2878 8.88159 17.1089 8.28522C16.93 7.68885 16.3137 7.35091 15.7173 7.52982C15.121 7.70873 14.783 8.32498 14.9619 8.92135Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8466 7.97631C15.3297 8.1254 15.0017 8.62237 15.0514 9.13923C15.0116 9.06965 14.9818 9.00007 14.9619 8.92056C14.783 8.32419 15.121 7.698 15.7173 7.52903C16.3137 7.35011 16.93 7.698 17.1089 8.28443C17.1288 8.36394 17.1486 8.43352 17.1486 8.51304C16.9001 8.05582 16.3634 7.81727 15.8466 7.96637L15.8466 7.97631Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5718 7.31053C18.711 7.77768 19.1583 8.05599 19.5757 7.93671C19.9932 7.81744 20.2119 7.3304 20.0727 6.86324C19.9336 6.39609 19.4863 6.11779 19.0688 6.23706C18.6514 6.35633 18.4327 6.84337 18.5619 7.31053L18.5718 7.31053Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1721 6.58494C18.8143 6.69427 18.5956 7.07198 18.6354 7.4795C18.6055 7.4298 18.5857 7.37016 18.5658 7.31052C18.4266 6.84336 18.6552 6.35633 19.0627 6.23706C19.4802 6.11779 19.9275 6.39609 20.0666 6.86324C20.0865 6.92288 20.0965 6.98252 20.1064 7.04216C19.9175 6.67439 19.5299 6.47561 19.1721 6.58494Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5128 4.41924C12.5128 4.96592 12.0655 5.41319 11.5189 5.41319C10.9722 5.41319 10.5249 4.96592 10.5249 4.41924C10.5249 3.87257 10.9722 3.42529 11.5189 3.42529C12.0655 3.42529 12.5128 3.87257 12.5128 4.41924Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5288 3.84276C12.0158 3.84276 12.4134 4.1807 12.5128 4.63791C12.5227 4.56834 12.5327 4.49876 12.5327 4.42918C12.5327 3.87257 12.0854 3.42529 11.5288 3.42529C10.9722 3.42529 10.5249 3.87257 10.5249 4.42918C10.5249 4.49876 10.5249 4.56834 10.5448 4.63791C10.6442 4.1807 11.0418 3.84276 11.5288 3.84276Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0734 3.99192C8.95413 4.40938 8.51679 4.63799 8.09933 4.51872C7.68187 4.39944 7.45326 3.9621 7.57254 3.54464C7.69181 3.12718 8.12915 2.89858 8.54661 3.01785C8.96407 3.13712 9.19268 3.57447 9.0734 3.99192Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45545 3.32521C8.81327 3.43454 9.04188 3.77248 9.01206 4.14024C9.04188 4.09055 9.06176 4.04086 9.0717 3.99116C9.19097 3.5737 8.96237 3.13636 8.54491 3.01708C8.12745 2.89781 7.70005 3.13636 7.57083 3.54388C7.55095 3.59357 7.54102 3.65321 7.54102 3.70291C7.70999 3.38485 8.08769 3.21587 8.45545 3.32521Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56062 2.92512C6.46122 3.25313 6.1531 3.45191 5.86485 3.36246C5.5766 3.273 5.41757 2.945 5.51697 2.61699C5.61636 2.28899 5.92449 2.09021 6.21274 2.17966C6.50098 2.26912 6.66001 2.59712 6.56062 2.92512Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12343 2.41821C6.37192 2.49772 6.53095 2.75615 6.50113 3.04439C6.52101 3.00463 6.54089 2.96488 6.55083 2.92512C6.65023 2.59712 6.4912 2.25918 6.20295 2.17966C5.9147 2.09021 5.59664 2.28899 5.50718 2.61699C5.49724 2.65675 5.4873 2.69651 5.4873 2.74621C5.61652 2.48779 5.88488 2.34863 6.14331 2.42815L6.12343 2.41821Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9207 3.99192C14.04 4.40938 14.4773 4.63799 14.8948 4.51872C15.3122 4.39944 15.5408 3.9621 15.4215 3.54464C15.3023 3.12718 14.8649 2.89858 14.4475 3.01785C14.03 3.13712 13.8014 3.57447 13.9207 3.99192Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5369 3.32521C14.1791 3.43454 13.9505 3.77248 13.9803 4.14024C13.9505 4.09055 13.9306 4.04086 13.9207 3.99116C13.8014 3.5737 14.03 3.13636 14.4475 3.01708C14.8649 2.89781 15.2923 3.13636 15.4215 3.54388C15.4414 3.59357 15.4514 3.65321 15.4514 3.70291C15.2824 3.38485 14.9047 3.21587 14.5369 3.32521Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4227 2.92512C16.5221 3.25313 16.8303 3.45191 17.1185 3.36246C17.4067 3.273 17.5658 2.945 17.4664 2.61699C17.367 2.28899 17.0589 2.09021 16.7706 2.17966C16.4824 2.26912 16.3233 2.59712 16.4227 2.92512Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8501 2.41821C16.6016 2.49772 16.4426 2.75615 16.4724 3.04439C16.4526 3.00463 16.4327 2.96488 16.4227 2.92512C16.3233 2.59712 16.4824 2.25918 16.7706 2.17966C17.0589 2.09021 17.3769 2.28899 17.4664 2.61699C17.4763 2.65675 17.4863 2.69651 17.4863 2.74621C17.357 2.48779 17.0887 2.34863 16.8303 2.42815L16.8501 2.41821Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1095 12.2545C10.1095 13.0099 9.49326 13.6261 8.73786 13.6261C7.98246 13.6261 7.36621 13.0099 7.36621 12.2545C7.36621 11.4991 7.98246 10.8828 8.73786 10.8828C9.49326 10.8828 10.1095 11.4991 10.1095 12.2545Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7478 11.4593C9.41375 11.4593 9.97036 11.9265 10.0996 12.5526C10.1195 12.4632 10.1294 12.3638 10.1294 12.2644C10.1294 11.4991 9.51314 10.8828 8.7478 10.8828C7.98246 10.8828 7.36621 11.4991 7.36621 12.2644C7.36621 12.3638 7.37615 12.4533 7.39603 12.5526C7.52524 11.9265 8.08185 11.4593 8.7478 11.4593Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6046 12.2545C15.6046 13.0099 14.9884 13.6261 14.233 13.6261C13.4776 13.6261 12.8613 13.0099 12.8613 12.2545C12.8613 11.4991 13.4776 10.8828 14.233 10.8828C14.9884 10.8828 15.6046 11.4991 15.6046 12.2545Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2429 11.4593C14.9089 11.4593 15.4655 11.9265 15.5947 12.5526C15.6146 12.4632 15.6245 12.3638 15.6245 12.2644C15.6245 11.4991 15.0083 10.8828 14.2429 10.8828C13.4776 10.8828 12.8613 11.4991 12.8613 12.2644C12.8613 12.3638 12.8713 12.4533 12.8911 12.5526C13.0204 11.9265 13.577 11.4593 14.2429 11.4593Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39735 11.565C5.22837 12.1315 4.64194 12.4496 4.07539 12.2906C3.50884 12.1216 3.19078 11.5352 3.35975 10.9686C3.52872 10.4021 4.11515 10.084 4.6817 10.243C5.24825 10.412 5.56632 10.9984 5.39735 11.565Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55689 10.6641C5.05386 10.8132 5.36199 11.2803 5.31229 11.7773C5.34211 11.7176 5.37193 11.6481 5.3918 11.5686C5.56078 11.002 5.23278 10.4056 4.67617 10.2466C4.10962 10.0776 3.52318 10.4056 3.35421 10.9722C3.33433 11.0418 3.32439 11.1213 3.31445 11.1909C3.553 10.7535 4.05992 10.5249 4.55689 10.674L4.55689 10.6641Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98546 10.1577C1.8463 10.6149 1.40896 10.8932 1.01138 10.7739C0.613803 10.6547 0.385196 10.1875 0.524349 9.73029C0.663502 9.27308 1.10084 8.99478 1.49842 9.11405C1.90594 9.23332 2.12461 9.70048 1.98546 10.1577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3879 9.45199C1.74572 9.55138 1.95445 9.92908 1.91469 10.3267C1.94451 10.277 1.96439 10.2173 1.98426 10.1577C2.12342 9.70048 1.90474 9.23332 1.49722 9.11405C1.0897 8.99478 0.652369 9.27308 0.513216 9.73029C0.493337 9.78993 0.483398 9.84957 0.483398 9.90921C0.662309 9.55138 1.04001 9.3526 1.39783 9.46193L1.3879 9.45199Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5829 11.565C17.7518 12.1315 18.3383 12.4496 18.9048 12.2906C19.4714 12.1216 19.7894 11.5352 19.6304 10.9686C19.4714 10.4021 18.875 10.084 18.3085 10.243C17.7419 10.412 17.4238 10.9984 17.5829 11.565Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4434 10.6641C17.9464 10.8132 17.6383 11.2803 17.688 11.7773C17.6582 11.7176 17.6284 11.6481 17.6085 11.5686C17.4395 11.002 17.7675 10.4056 18.3241 10.2466C18.8907 10.0776 19.4771 10.4056 19.6461 10.9722C19.6659 11.0418 19.6759 11.1213 19.6858 11.1909C19.4473 10.7535 18.9404 10.5249 18.4434 10.674L18.4434 10.6641Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0302 10.1577C21.1694 10.6149 21.6067 10.8932 22.0043 10.7739C22.4118 10.6547 22.6305 10.1875 22.4913 9.73029C22.3522 9.27308 21.9148 8.99478 21.5172 9.11405C21.1197 9.23332 20.8911 9.70048 21.0302 10.1577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6056 9.45199C21.2478 9.55138 21.039 9.92908 21.0788 10.3267C21.049 10.277 21.0291 10.2173 21.0092 10.1577C20.8701 9.70048 21.0887 9.23332 21.4962 9.11405C21.9038 8.99478 22.3411 9.27308 22.4802 9.73029C22.5001 9.78993 22.5101 9.84957 22.5101 9.90921C22.3312 9.55138 21.9535 9.3526 21.5956 9.46193L21.6056 9.45199Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41816 7.56434C9.99455 7.56434 10.4618 7.09708 10.4618 6.52069C10.4618 5.9443 9.99455 5.47705 9.41816 5.47705C8.84177 5.47705 8.37451 5.9443 8.37451 6.52069C8.37451 7.09708 8.84177 7.56434 9.41816 7.56434Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4281 5.91439C9.93502 5.91439 10.3624 6.27221 10.4618 6.7493C10.4717 6.67973 10.4817 6.61015 10.4817 6.53063C10.4817 5.9442 10.0145 5.47705 9.4281 5.47705C8.84167 5.47705 8.37451 5.9442 8.37451 6.53063C8.37451 6.60021 8.37452 6.67973 8.39439 6.7493C8.49379 6.27221 8.92119 5.91439 9.4281 5.91439Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5886 7.56337C14.165 7.56337 14.6322 7.09611 14.6322 6.51972C14.6322 5.94333 14.165 5.47607 13.5886 5.47607C13.0122 5.47607 12.5449 5.94333 12.5449 6.51972C12.5449 7.09611 13.0122 7.56337 13.5886 7.56337Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5985 5.91341C14.1054 5.91341 14.5328 6.27123 14.6322 6.74833C14.6422 6.67875 14.6521 6.60917 14.6521 6.52966C14.6521 5.94323 14.1849 5.47607 13.5985 5.47607C13.0121 5.47607 12.5449 5.94323 12.5449 6.52966C12.5449 6.59923 12.5449 6.67875 12.5648 6.74833C12.6642 6.27123 13.0916 5.91341 13.5985 5.91341Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8667 5.9919C6.73749 6.4193 6.29021 6.66778 5.85287 6.53857C5.42547 6.40936 5.17698 5.96208 5.30619 5.52474C5.43541 5.09735 5.88269 4.84886 6.31009 4.97807C6.73748 5.10728 6.98597 5.55456 6.85676 5.9919L6.8667 5.9919Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20419 5.30602C6.58189 5.41535 6.81049 5.77317 6.78068 6.15087C6.81049 6.10118 6.83038 6.05148 6.84032 5.99185C6.96953 5.56445 6.72104 5.10723 6.29364 4.97801C5.86624 4.8488 5.40903 5.09729 5.27982 5.53463C5.25994 5.59427 5.25 5.64396 5.25 5.7036C5.42891 5.36566 5.81655 5.19668 6.19425 5.30602L6.20419 5.30602Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23564 4.92621C4.13624 5.27409 3.7983 5.48282 3.49017 5.39336C3.18205 5.30391 3.01308 4.94609 3.11248 4.59821C3.21187 4.25033 3.54981 4.0416 3.85794 4.13105C4.16606 4.22051 4.33503 4.57832 4.23564 4.92621Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78969 4.38947C4.05805 4.46899 4.21709 4.7473 4.18727 5.05542C4.20715 5.01567 4.22702 4.9759 4.23696 4.92621C4.33636 4.57832 4.17733 4.22051 3.85926 4.13105C3.55114 4.0416 3.2132 4.25033 3.1138 4.59821C3.10386 4.63797 3.09392 4.68766 3.08398 4.72742C3.22314 4.45905 3.51138 4.30996 3.77975 4.38947L3.78969 4.38947Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1226 5.9919C16.2518 6.4193 16.6991 6.66778 17.1265 6.53857C17.5539 6.40936 17.8024 5.96208 17.6732 5.52474C17.5439 5.09735 17.0967 4.84886 16.6693 4.97807C16.2419 5.10728 15.9934 5.55456 16.1226 5.9919Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7587 5.30602C16.381 5.41535 16.1524 5.77317 16.1822 6.15087C16.1524 6.10118 16.1325 6.05148 16.1226 5.99185C15.9934 5.56445 16.2419 5.10723 16.6693 4.97801C17.0967 4.8488 17.5539 5.09729 17.6831 5.53463C17.703 5.59427 17.7129 5.64396 17.7129 5.7036C17.534 5.36566 17.1464 5.19668 16.7687 5.30602L16.7587 5.30602Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7555 4.92621C18.8549 5.27409 19.1929 5.48282 19.501 5.39336C19.8091 5.30391 19.9781 4.94609 19.8787 4.59821C19.7793 4.25033 19.4414 4.0416 19.1332 4.13105C18.8251 4.22051 18.6561 4.57832 18.7555 4.92621Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2037 4.38947C18.9354 4.46899 18.7764 4.7473 18.8062 5.05542C18.7863 5.01567 18.7664 4.9759 18.7565 4.92621C18.6571 4.57832 18.8161 4.22051 19.1342 4.13105C19.4423 4.0416 19.7802 4.25033 19.8796 4.59821C19.8896 4.63797 19.8995 4.68766 19.9095 4.72742C19.7703 4.45905 19.4821 4.30996 19.2137 4.38947L19.2037 4.38947Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallcon);
export default __webpack_public_path__ + "static/media/ballcon.1217f9c7dedb9302fbe69c3ac1808bb0.svg";
export { ForwardRef as ReactComponent };